<div class="text-grey" style="position: relative;">
  <div class="modal-header">
    <div [style.background]="'url(' + image + ')'" class="iconImage"></div>
    <h4 class="modal-title synchpc-primary ms-2" id="modal-title">{{ cloudName }} - {{ dialogTitle }}</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <form name="createDeploymentForm">
      <div style="height: 62vh;
        max-height: 62vh;
        overflow-y: auto;">
        <table class="table table-hover table-sm" #customHtmlBody
               *ngIf="htmlBody != ''" [innerHTML]="htmlBody | safeHtml">
        </table>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <mat-checkbox #skipDeployment style="width: 40%;" *ngIf="showSkipDeployment">
      Skip Infra Deployment
    </mat-checkbox>
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!currentUserRole">Submit</button>
  </div>
  <ngx-spinner bdColor="rgba(236,236,236,0.8)"
               size="default" zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="true"
               name="addDeployment">
  </ngx-spinner>
</div>
